import { Controller } from '@hotwired/stimulus'

// Mobile-only segmented control (Sandy & Server / Your Tab)
export default class extends Controller {
  static targets = ['chatPane', 'tabPane', 'segmentChat', 'segmentTab']

  switchTo(event) {
    const pane = event.params.pane // "chat" | "tab"

    if (this.hasChatPaneTarget) this.chatPaneTarget.toggleAttribute('data-active', pane === 'chat')
    if (this.hasTabPaneTarget) this.tabPaneTarget.toggleAttribute('data-active', pane === 'tab')
    if (this.hasSegmentChatTarget) this.segmentChatTarget.classList.toggle('is-active', pane === 'chat')
    if (this.hasSegmentTabTarget) this.segmentTabTarget.classList.toggle('is-active', pane === 'tab')
  }
}
